export const CATEGORYFILTER = "filter/category";
export const AUTHORFILTER = "filter/author";
export const TITLEFILTER = "filter/title";
